module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("By")]), _vm._v(" D.W. M"), _c('span', {
    staticClass: "t8"
  }, [_vm._v("ARCHWELL")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("All That Heaven Will Allow")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Comfort")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Even the Innocent")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Falling • When Memory Fails")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("A Fine Mingling")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Mitchell’s Presence")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Pictures on Silence")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("The Shared Harvest")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Sins of the Father")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("A Still, Small Voice")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Until")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Wishing on a Blue Star (Dreamspinner Anthology)")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t9"
  }, [_vm._v("G")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("OOD")]), _vm._v(" "), _c('span', {
    staticClass: "t10"
  }, [_vm._v("TO")]), _vm._v(" "), _c('span', {
    staticClass: "t9"
  }, [_vm._v("K")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("NOW")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Good to Know")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("An Earlier Heaven")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Roots and Wings")])]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Published by")]), _vm._v(" D"), _c('span', {
    staticClass: "t8"
  }, [_vm._v("REAMSPINNER")]), _vm._v(" P"), _c('span', {
    staticClass: "t8"
  }, [_vm._v("RESS")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("http://www.dreamspinnerpress.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47a756e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/003.vue
// module id = 60
// module chunks = 0